import React, { useCallback, useEffect, useMemo, useState } from "react";
import { BodyText, Heading, Icon, Input } from "../../elements";
import { AnimatePresence, motion } from "framer-motion";
import classNames from "classnames";
import { gtag } from "../../utils";
import { getOverallSettingsClasses } from "../../utils/siteUtils";
import "./style.scss";
const FAQ = props => {
  const { fields, page } = props;
  const { headingType, hideSearch, heading, keywordLabel, keywordIcon, expandFirst, moreText, closeText, contents } = fields;
  const size = 8;
  const qaItems = useMemo(
    () =>
      contents.map((x, index) => ({
        id: x.id,
        question: x.fields.question.value,
        answer: x.fields.answer.value,
        expanded: expandFirst?.value && index === 0
      })),
    [contents]
  );
  const [shownItems, setShownItems] = useState(qaItems);
  const [showAll, setShowAll] = useState(false);
  const [keyword, setKeyword] = useState("");
  const visibleItems = useMemo(() => (showAll || shownItems.length <= size ? shownItems : shownItems.slice(0, size)), [showAll, shownItems]);
  const toggleExpand = item => {
    gtag('event', 'Component_info', {
      'component_name': 'FAQ',
      'page_title': page?.name
    });
    const _item = shownItems.find(x => x.id === item.id);
    _item.expanded = !_item.expanded;
    setShownItems([...shownItems]);
  };
  const searchProps = {
    placeholder: keywordLabel.value,
    value: keyword,
    onChange(e) {
      const val = e.target.value;
      const reg = new RegExp(`${val}`, "gi");
      const items = qaItems.filter(x => reg.test(x.question) || reg.test(x.answer));
      if (items.length > 0 && expandFirst?.value) {
        items[0].expanded = true;
      }
      setShownItems(items);
    },
    onBlur(e) {
      const val = e.target.value;
      setKeyword(val);
    }
  };
  const toggleMore = useCallback(() => {
    gtag('event', 'Component_info', {
      'component_name': 'FAQ',
      'page_title': page?.name
    });
    setShowAll(!showAll);
  }, [showAll]);
  const rootClass = classNames("c-faq grid", getOverallSettingsClasses(fields));
  return (
    <div className={rootClass}>
      <div className="c-faq__header">
        <Heading html={heading} type={headingType} className="c-faq__title" />
        <div className="c-faq__search">
          {!hideSearch?.value && <Input className="c-faq__search" {...searchProps} />}
          {keywordIcon && <Icon className="c-faq__search-icon" icon={keywordIcon.value} />}
        </div>
      </div>
      <div className="c-faq__items">
        {visibleItems.map(item => (
          <FAQItem {...{ item, toggleExpand }} key={item.id} />
        ))}
      </div>
      {shownItems.length > size && (
        <div className="c-faq__more">
          <Icon name={showAll ? "ExpandLess" : "ExpandMore"} className="c-faq__more-icon" onClick={toggleMore} />
          <div className="c-faq__more-text __f-h4" onClick={toggleMore}>
            {showAll ? closeText.value : moreText.value}
          </div>
        </div>
      )}
    </div>
  );
};
const FAQItem = ({ item, toggleExpand }) => {
  const { expanded, question, answer } = item;
  const itemAnimation = {
    initial: "collapsed",
    animate: "open",
    exit: "collapsed",
    variants: {
      open: { opacity: 1, height: "auto" },
      collapsed: { opacity: 0, height: 0 }
    },
    transition: { duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98] }
  };
  return (
    <div className="c-faq__item">
      <div className="c-faq__item-header" onClick={e => toggleExpand(item)}>
        <BodyText html={question} className="c-faq__item-title __f-h4" tagName="h4" />
        <i className={classNames("c-faq__item-trigger", { active: item.expanded })} />
      </div>
      <AnimatePresence>
        {expanded && (
          <motion.div className="c-faq__item-answer" {...itemAnimation}>
            <BodyText html={answer} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
export default FAQ;
